// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1lTpZ","content":"RecentSearches_content__hQT3c"};